import React from 'react';
import styled from 'styled-components';

export enum IconPosition {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

interface IIconViewWidget {
  label: string;
  icon: React.ReactElement;
  iconPosition?: IconPosition;
}

const IconViewWidgetContainer = styled.div`
  color: ${({ theme }) => theme.colors.Tarpon};
  font-size: ${({ theme }) => theme.fontSize.s};
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
const IconViewWidgetLabel = styled.span``;
const IconViewWidgetValue = styled.span`
  display: flex;
  align-items: center;
  font-weight: normal;
`;

const IconViewWidget: React.FC<IIconViewWidget> = ({
  label,
  icon,
  iconPosition = IconPosition.LEFT,
}) => {
  if (iconPosition === IconPosition.LEFT) {
    return (
      <IconViewWidgetContainer>
        <IconViewWidgetValue>{icon}</IconViewWidgetValue>
        <IconViewWidgetLabel>{label} </IconViewWidgetLabel>
      </IconViewWidgetContainer>
    );
  }
  return (
    <IconViewWidgetContainer>
      <IconViewWidgetLabel>{label} </IconViewWidgetLabel>
      <IconViewWidgetValue>{icon}</IconViewWidgetValue>
    </IconViewWidgetContainer>
  );
};

export { IconViewWidget };
